import { render, staticRenderFns } from "./TheVerticalNavigation.vue?vue&type=template&id=0c5af15d&scoped=true&"
import script from "./TheVerticalNavigation.vue?vue&type=script&lang=js&"
export * from "./TheVerticalNavigation.vue?vue&type=script&lang=js&"
import style0 from "./TheVerticalNavigation.vue?vue&type=style&index=0&id=0c5af15d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5af15d",
  null
  
)

export default component.exports